"use client"

import { PortfolioUIState } from "../../page"
import { useEffect, useMemo, useState } from "react"
import { useSearchParams } from "next/navigation"

export enum PortfolioEditModal {
  EditAbout = "EditAbout",
  EditLocation = "EditLocation",
  EditName = "EditName",
  EditRoles = "EditRoles",
  EditSkills = "EditSkills",
  EditProjecTypes = "EditProjecTypes",
  EditLanguages = "EditLanguages",
  ReorderProjects = "ReorderProjects",
  DeleteProject = "DeleteProject",
  EditDescription = "EditDescription",
  EditContactInfo = "EditContactInfo",
  UpdateAvatarImage = "UpdateAvatarImage",
  ProfileVisibility = "ProfileVisibility",
}

export type UseEditPortfolio = ReturnType<typeof useEditPortfolio>

export const useEditPortfolio = (uiState: PortfolioUIState) => {
  const searchParams = useSearchParams()
  const [isEditing, setIsEditing] = useState(false)
  const [openModal, setOpenModal] = useState<PortfolioEditModal | null>(null)
  const [deleteProjectId, setDeleteProjectId] = useState<string | null>(null)

  const currentParams = useMemo(() => {
    const params: { [key: string]: string } = {}
    searchParams?.forEach((value, key) => {
      params[key] = value
    })
    return params
  }, [searchParams])

  const toggleEdit = (edit: boolean) => {
    const updatedParams = new URLSearchParams(currentParams as Record<string, string>)

    if (edit) {
      updatedParams.set("edit", "true")
      setIsEditing(true)
    } else {
      updatedParams.delete("edit")
      setIsEditing(false)
    }

    window.history.replaceState(null, "", `?${updatedParams.toString()}`)
  }

  useEffect(() => {
    // Check if the "edit" param is present on page load
    if (uiState?.isUsersPortfolio) {
      const currentParams = new URLSearchParams(window.location.search)
      const isEditParamPresent = currentParams.get("edit") === "true"

      if (isEditParamPresent) {
        setIsEditing(true)
      } else {
        setIsEditing(false)
      }
    } else {
      setIsEditing(false)
    }
  }, [setIsEditing, uiState])

  return { openModal, setOpenModal, isEditing, toggleEdit, setDeleteProjectId, deleteProjectId }
}
